import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { PS } from '../theme';
import { Icon } from '../lib/icons';
import { notifySuccess, notifyError } from '../lib/toast';
import { track } from '../lib/analytics';

// Share card: deep link to the circle + scannable QR + copy / native share.
export default function ShareSheet({ circle, onClose }) {
  const url = `${window.location.origin}/app/circle/${circle.circle_id}`;
  const shareText = `ชวนเข้าวงแชร์ "${circle.name}" บน Peershare — เปิดดูรายละเอียดและขอเข้าร่วมได้เลย`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      track('invite_shared', { circle_id: circle.circle_id, method: 'copy' });
      notifySuccess('คัดลอกลิงก์แล้ว');
    } catch { notifyError('คัดลอกไม่สำเร็จ — แตะค้างที่ลิงก์เพื่อคัดลอกเอง'); }
  };
  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: circle.name, text: shareText, url });
        track('invite_shared', { circle_id: circle.circle_id, method: 'native' });
      } catch { /* cancelled */ }
    } else { copy(); }
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(20,18,16,0.5)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 1600 }}>
      <div onClick={e => e.stopPropagation()} className="ps-fade-up" data-testid="share-sheet" style={{ width: '100%', maxWidth: 460, background: PS.surface2, borderRadius: '24px 24px 0 0', padding: '20px 20px max(20px, env(safe-area-inset-bottom))', fontFamily: PS.fontUI, textAlign: 'center', position: 'relative' }}>
        <div style={{ width: 40, height: 4, borderRadius: 2, background: PS.line, margin: '0 auto 18px' }} />
        <button data-testid="share-close-btn" onClick={onClose} className="ps-press" aria-label="ปิด" style={{ position: 'absolute', top: 16, right: 16, width: 30, height: 30, borderRadius: 15, background: PS.panel, border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon.x size={15} stroke={PS.textMuted} /></button>
        <div style={{ fontSize: 17, fontWeight: 700 }}>ชวนเพื่อนเข้าวง</div>
        <div style={{ fontSize: 12.5, color: PS.textMuted, marginTop: 4 }}>{circle.name}</div>

        <div style={{ display: 'inline-block', margin: '20px auto', padding: 16, background: '#fff', borderRadius: 18, border: `1px solid ${PS.line}` }}>
          <QRCodeSVG data-testid="share-qr" value={url} size={180} fgColor={PS.ink} level="M" />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: PS.panel, borderRadius: 12, padding: '10px 12px', marginBottom: 14 }}>
          <Icon.pin size={14} stroke={PS.textMuted} />
          <div data-testid="share-link" style={{ flex: 1, fontSize: 12, color: PS.text, textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{url}</div>
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <button data-testid="share-copy-btn" onClick={copy} className="ps-press" style={{ flex: 1, height: 50, background: 'transparent', border: `1px solid ${PS.line}`, borderRadius: 14, fontSize: 13.5, fontWeight: 600, fontFamily: PS.fontUI, color: PS.text, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7 }}>
            <Icon.doc size={16} stroke={PS.ink} /> คัดลอกลิงก์
          </button>
          <button data-testid="share-native-btn" onClick={share} className="ps-press" style={{ flex: 1, height: 50, background: PS.ink, color: PS.page, border: 'none', borderRadius: 14, fontSize: 13.5, fontWeight: 600, fontFamily: PS.fontUI, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7 }}>
            <Icon.send size={16} stroke={PS.page} /> แชร์
          </button>
        </div>
        <div style={{ fontSize: 11, color: PS.textMuted, marginTop: 14, lineHeight: 1.5 }}>
          {circle.visibility === 'private'
            ? '🔒 วงส่วนตัว — เข้าร่วมได้เฉพาะผู้มีลิงก์/QR นี้เท่านั้น (ไม่ขึ้นในหน้าค้นหา)'
            : 'ใครเปิดลิงก์/สแกน QR ก็ดูรายละเอียดวงและกดขอเข้าร่วมได้ทันที'}
        </div>
      </div>
    </div>
  );
}
